module.exports = __webpack_public_path__ + "img/phd.86294dfa.svg";